export default __webpack_public_path__ + "static/getstarted1-9161f3dc7742151ade829e51cbe7b843.png";